import React, { useState, useEffect } from 'react';
import { Typography } from '@mui/material';

const TypewriterText = ({ lines, variant, fontSize }) => {
  const [currentLineIndex, setCurrentLineIndex] = useState(0);
  const [currentCharIndex, setCurrentCharIndex] = useState(0);
  const [displayedText, setDisplayedText] = useState([]);

  useEffect(() => {
    const line = lines[currentLineIndex].text;
    const handleTimeout = () => {
      if (currentCharIndex < line.length) {
        const newDisplayedText = [...displayedText];
        newDisplayedText[currentLineIndex] = line.substring(0, currentCharIndex + 1);
        setDisplayedText(newDisplayedText);
        setCurrentCharIndex(currentCharIndex + 1);
      } else if (currentLineIndex < lines.length - 1) {
        setCurrentLineIndex(currentLineIndex + 1);
        setCurrentCharIndex(0);
      } else {
        // Reset to start the animation over after the last line
        setTimeout(() => {
          setDisplayedText([]);
          setCurrentLineIndex(0);
          setCurrentCharIndex(0);
        },1000); // Pause before restarting the animation
      }
    };

    const timeoutId = setTimeout(handleTimeout, currentCharIndex < line.length ? 50 : 150);
    return () => clearTimeout(timeoutId);
  }, [currentCharIndex, currentLineIndex, lines, displayedText]);

  return (
    <div>
      {displayedText.map((line, index) => (
        <Typography key={index} variant={variant} fontSize={fontSize} style={lines[index].style}>
          {line}
          {index < displayedText.length - 1 ? <br /> : ''}
        </Typography>
      ))}
    </div>
  );
};

export default TypewriterText;
